import {useStyles} from '@wix/tpa-settings/react'
import classNames from 'classnames'
import React from 'react'
import {PROMOTIONAL_BADGE} from '../../../../../settings-commons/components/promotional-badges/interfaces'
import stylesParams from '../../../stylesParams'
import {useWidgetState} from '../../hooks/state-provider'
import {getForcedPromotionalBadge} from '../../selectors/layout'
import {PromotionalBadgeProps} from './interfaces'
import s from './promotional-badge.scss'

export const PromotionalBadge = ({onImage}: PromotionalBadgeProps) => {
  const {get} = useStyles()

  const fullWidth = get(stylesParams.promotionalBadgeStretched)
  const forcedPromotionalBadge = useWidgetState(getForcedPromotionalBadge)
  const label =
    forcedPromotionalBadge === PROMOTIONAL_BADGE.FIRST_PRIORITY
      ? 'First'
      : forcedPromotionalBadge === PROMOTIONAL_BADGE.SECOND_PRIORITY
      ? 'Second'
      : 'Third'

  return (
    <div className={onImage ? s.container : undefined}>
      <div data-hook="promotional-badge" className={classNames(s.badge, {[s.fullWidth]: onImage && fullWidth})}>
        <div>{label}</div>
      </div>
    </div>
  )
}
